import React, { useState } from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';

import {
  ClientNameInput,
  ContentBlock,
  Description,
  InputButtonGroup,
  RightSection,
  SectionWrapper,
  Title,
} from '../EnvironmentSetup.styles';

interface IClientNameSectionProps {
  clientName: string;
  onSave: (state: { clientName: string }) => any;
}
export const ClientNameSection = ({
  clientName: originalClientName,
  onSave,
}: IClientNameSectionProps) => {
  const [clientName, setClientName] = useState(originalClientName || '');
  const handleSave = () => {
    onSave({ clientName });
  };
  const saveDisabled = clientName === originalClientName;

  return (
    <SectionWrapper animationIndex={0}>
      <Title>Client Name</Title>
      <ContentBlock>
        <Description>
          Configure your environment for your client, this will appear in header
          of the report portal.
        </Description>
        <RightSection>
          <InputButtonGroup>
            <ClientNameInput
              label="Client name"
              defaultValue={originalClientName}
              onChange={setClientName}
            />
            <ApButtonMain disabled={saveDisabled} onClick={handleSave}>
              Save
            </ApButtonMain>
          </InputButtonGroup>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
